import React from 'react';
import styles from './FleetSaleScrollFixedImages.module.scss';
import { useMediaQuery } from 'usehooks-ts';

export default function FleetSaleScrollFixedImages({ data }) {
  const isMobile = useMediaQuery('(max-width: 480px)');
  return (
    <div className={styles.wrapper} data-aos="fade-up">
      {data.map((item) => {
        return (
          <div key={item.id} className={styles.imageWrapper}>
            <div className={styles.item}>
              {isMobile ? (
                <img
                  src={item?.fields?.mobileImage?.value.src}
                  alt={item?.fields?.mobileImage?.value.alt}
                  width={item?.fields?.mobileImage?.value.width}
                  height={item?.fields?.mobileImage?.value.height}
                />
              ) : (
                <img
                  src={item?.fields?.desktopImage?.value?.src}
                  alt={item?.fields?.desktopImage?.value?.alt}
                  width={item?.fields?.desktopImage?.value?.width}
                  height={item?.fields?.desktopImage?.value?.height}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
